<template>
    <div>
        <div class="app-widget__head">
            <div class="head-selection">
                <div class="head-selection__item">
                    <Select type="clinics"
                            label="Клиника"
                            :list="dictionaryData.clinics"
                            placeholder="Выбор клиники"
                            :onChange="onChangeSelect"
                            :value="selectedData.clinics"
                            :clearSelected="clearSelectedOption">
                    </Select>
                </div>
                <div class="head-selection__item">
                    <Select type="services"
                            label="Услуга"
                            :list="dictionaryData.services"
                            placeholder="Выбор услуги"
                            :onChange="onChangeSelect"
                            :value="selectedData.services"
                            :clearSelected="clearSelectedOption">
                    </Select>
                </div>

                <div class="head-selection__item">
                    <Select type="doctors"
                            label="Врач"
                            :list="dictionaryData.doctors"
                            placeholder="Выбор врача"
                            :onChange="onChangeSelect"
                            :value="selectedData.doctors"
                            :clearSelected="clearSelectedOption">
                    </Select>
                </div>
                <div class="head-selection__item head-selection__item--clear">
                    <div class="reset-all" @click="resetAll">Сбросить все</div>
                </div>
            </div>
        </div>
        <div class="app-widget__body">
            <div class="body-selection">

                <div class="body-selection__item body-selection__item--clinics">
                    <div class="body-selection__label">Клиника
                        <div v-if="selectedData.clinics" class="body-selection__clear" @click="clearSelectedOption('clinics')">
                            <img src="../../public/img/telemedicine-widget-images/cross.svg" alt="">
                        </div>
                    </div>
                    <SelectionList :data="dictionaryData.clinics"
                                   type="clinics"
                                   :onSelect="onChangeSelect"
                                   :selectedData="selectedData.clinics"
                                   :clearSelected="clearSelectedOption">
                    </SelectionList>
                </div>

                <div class="body-selection__item">
                    <div class="body-selection__label">Услуги
                        <div v-if="selectedData.services" class="body-selection__clear" @click="clearSelectedOption('services')">
                            <img src="../../public/img/telemedicine-widget-images/cross.svg" alt="">
                        </div>
                    </div>
                    <SelectionList :data="dictionaryData.services"
                                   type="services"
                                   :onSelect="onChangeSelect"
                                   :selectedData="selectedData.services"
                                   :clearSelected="clearSelectedOption">
                    </SelectionList>
                </div>

                <div class="body-selection__item">
                    <div class="body-selection__label">Врач
                        <div v-if="selectedData.doctors" class="body-selection__clear" @click="clearSelectedOption('doctors')">
                            <img src="../../public/img/telemedicine-widget-images/cross.svg" alt="">
                        </div>
                    </div>
                    <SelectionList :data="dictionaryData.doctors"
                                   type="doctors"
                                   :onSelect="onChangeSelect"
                                   :selectedData="selectedData.doctors"
                                   :clearSelected="clearSelectedOption">
                    </SelectionList>
                </div>

                <div class="body-selection__item body-selection__item--date">
                    <div class="body-selection__label">дата</div>
                    <DatePicker :dates="dictionaryData.dates"
                                type="date"
                                :onselect="selectDatePicker"
                                :value="selectedData.date"
                    >
                    </DatePicker>
                </div>

                <div class="body-selection__item">
                    <div class="body-selection__label">время</div>
                    <TimeList type="timeslot"
                        v-if="dateAndPricing.times"
                        :data="dateAndPricing.times"
                        :selectTimeSlot="selectTimeSlot"
                        :selectedTimeSlot="selectedData.timeslot"/>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="app-widget__footer" v-if="dateAndPricing.date">
                <p class="app-widget__price"
                   v-if="price"
                   v-html="price"></p>
                <div class="row" v-if="getSms">
                    <div class="field">
                        <input
                                @input="updatePhone"
                                v-model="phone"
                                class="input"
                                type="text"
                                placeholder="Ваш телефон"
                                v-mask="['+7 (###) ###-####']"
                        >
                    </div>
                    <div class="field">
                        <input @input="updateEmail" class="input" type="email" placeholder="E-mail (необязательно)">
                    </div>
                </div>
                <div class="row" v-if="!getSms">
                    <div class="field">
                        <input
                                @input="updateCode"
                                type="text"
                                id="code"
                                placeholder="Код из SMS"
                                v-mask="['####']"
                                v-model="code"
                                class="input"
                                ref="inputSms"
                        />
                    </div>

                    <div class="field">
                        <div class="input-code__counter">Повтор через {{counterTimer}} сек.</div>
                    </div>
                </div>
                <div class="app-widget__submit">
                    <button
                            v-if="getSms"
                            class="app-widget__btn button"
                            @click="createAppointment"
                            :disabled="!(selectedData.clinics && selectedData.doctors && selectedData.services && selectedData.date && selectedData.timeslot && phoneIsValid)">
                        ЗАПИСАТЬСЯ
                    </button>
                    <button
                            v-if="!getSms"
                            class="app-widget__btn button"
                            :disabled="!(code.length > 0)"
                            @click="confirmCode">
                        Подтвердить
                    </button>
                    <div class="terms">Нажимая на кнопку "Записаться" вы соглашаетесь на обработку
                      персональных данных в соответствии с <a :href="$agreementUrl" target="_blank"
                                                              class="link link-blue">Условиями</a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import DatePicker from '@/components/DatePicker';
import Select from '@/components/Select';
import SelectionList from '@/components/SelectionList';
import moment from 'moment';
import TimeList from '@/components/TimeList';
import { mask } from 'vue-the-mask'

export default {
    name: 'step-two',
    data() {
      return {
        price: '',
        phoneIsValid: false,
        code: '',
        phone: this.phoneNumber,
        counterTimer: 60,
        counterStarted: false,
        counterInstanse: '',
      }
    },
    props: [
        'dictionaryData',
        'selectedData',
        'dateAndPricing',
        'phoneNumber',
        'getSms',
        'repeatPhone'
    ],
    directives: {mask},
    watch: {
        dateAndPricing: function () {
            this.setPrice();
        },
        getSms(value){
            if(!value){
                setTimeout(() => this.$refs.inputSms.focus(), 500)
            }
        }

    },
    components: {
        DatePicker,
        Select,
        SelectionList,
        TimeList
    },
    methods: {
      onChangeSelect(field, value) {
        this.selectedData[field] = value;
        this.allSelected();
        this.$emit('lastFilter', field);
      },
      clearSelectedOption(field) {
        this.selectedData[field] = null;
        this.allSelected();
      },
      selectDatePicker(date) {
        this.selectedData['date'] = moment(date).toISOString();
        this.allSelected();
      },
      resetAll() {
        this.$emit('resetAll');
      },
      allSelected() {
        this.$emit('allFiltersSelected');
      },
      selectTimeSlot(value) {
        this.selectedData['timeslot'] = value;
      },
      setPrice() {
        this.price = this.dateAndPricing.price === 0 ?
            'Бесплатная консультация' : '';
            /*`К оплате <strong>${this.dateAndPricing.price} руб.<strong>`*/
      },
      createAppointment() {
        if (!this.repeatPhone) {
          this.$emit('createAppointment');
        } else {
          this.$emit('approvePhoneAgaine');
        }
        this.counterDown();
      },
      updatePhone(val) {
        this.$emit('updatePhone', val.target.value);
        this.phoneIsValid = val.target.value.length >= 17;
      },
      updateCode(val) {
        this.$emit('updateCode', val.target.value)
      },
      updateEmail(val) {
        this.$emit('updateEmail', val.target.value)
      },
      confirmCode() {
        this.$emit('confirmCode');
      },
      counterDown(){
        this.counterStarted = true;
        this.counterInstanse = setInterval(() => {
          if(this.counterTimer <= 0) {
            this.stopCounter();
            this.$emit('repeatSms');
          } else {
            --this.counterTimer
          }
        }, 1000);
      },
      stopCounter(){
        if(this.counterStarted) {
          clearInterval(this.counterInstanse);
          this.counterTimer = 60;
          this.counterStarted = false;
        }
      },
    },
}
</script>

<style lang="sass">
    .app-widget
        &__footer
            margin: 40px 0 0
        &__price
            margin: 0 0 30px
        &__btn
            max-width: 220px
            width: 100%
    .row
        display: flex

        @media all and (max-width: 768px)
            flex-wrap: wrap

        .field
            margin-bottom: 20px
            position: relative
            flex: 0 0 calc(33.33% - 10px)
            display: flex
            align-items: center

            &:not(:last-child)
                margin-right: 20px

            @media all and (max-width: 768px)
                flex: 1 0 100%
                &:not(:last-child)
                    margin-right: 0

</style>
